var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main-content"},[_c('list',{attrs:{"columns":_vm.columns,"rows":_vm.rows}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }